export default __webpack_public_path__ + "static/media/img-ovato-mascot-who-hoo.f8513fa2.jpg";